import React from 'react';

const ContactPage = () => {
  const isMobile = window.innerWidth <= 600;

  return (
    <div style={styles.container}>

      {/* Top Banner */}
      <div style={{
        ...styles.banner,
        flexDirection: isMobile ? 'column' : 'row',
        padding: isMobile ? '16px 20px' : styles.banner.padding,
        gap: isMobile ? '8px' : '0'
      }}>

        <span style={{
          ...styles.leftInfo,
          marginRight: isMobile ? '0' : styles.leftInfo.marginRight,
          fontSize: isMobile ? '16px' : '18px'
        }}>
          📞 07801 753368
        </span>

        <span style={{
          ...styles.centerText,
          position: isMobile ? 'static' : 'absolute',
          transform: isMobile ? 'none' : 'translateX(-50%)',
          fontSize: isMobile ? '22px' : '26px'
        }}>
          Contact Us
        </span>

        <span style={{
          ...styles.rightInfo,
          marginLeft: isMobile ? '0' : styles.rightInfo.marginLeft,
          fontSize: isMobile ? '16px' : '18px',
          textAlign: 'center'
        }}>
          📧 b.wscaffoldingco@gmail.com
        </span>

      </div>

      {/* Notice Message */}
      <div style={styles.notice}>
        ⚠️ Sorry, but this feature does not work right now.
      </div>

      {/* Contact Form */}
      <div style={styles.formBox}>
        <form style={styles.form}>
          <input type="text" placeholder="Your Name" disabled style={styles.input}/>
          <input type="email" placeholder="Your Email" disabled style={styles.input}/>
          <textarea placeholder="Your Message" disabled style={styles.textarea}/>
          <button type="button" disabled style={styles.button}>
            Send Message
          </button>
        </form>
      </div>

    </div>
  );
};

const styles = {
  container:{
    display:'flex',
    flexDirection:'column',
    alignItems:'center',
    padding:'40px 20px'
  },

  banner:{
    display:'flex',
    alignItems:'center',
    justifyContent:'space-between',
    width:'100%',
    maxWidth:'900px',
    background:'#f5f5f5',
    padding:'12px 40px',
    borderRadius:'12px',
    marginBottom:'20px',
    boxShadow:'0 2px 8px rgba(0,0,0,0.1)',
    position:'relative',
    minHeight:'50px',
  },

  leftInfo:{
    fontSize:'18px',
    fontWeight:'600',
    marginRight:'60px',
    textAlign:'left',
  },

  rightInfo:{
    fontSize:'18px',
    fontWeight:'600',
    marginLeft:'60px',
    textAlign:'right',
  },

  centerText:{
    position:'absolute',
    left:'50%',
    transform:'translateX(-50%)',
    fontSize:'26px',
    fontWeight:'700',
    textAlign:'center',
  },

  notice:{
    marginBottom:'25px',
    color:'#b30000',
    fontWeight:'800',
    textAlign:'center',
    fontSize:'20px',
    textShadow:'1px 1px 2px rgba(0,0,0,0.3)',
  },

  formBox:{
    width:'100%',
    maxWidth:'600px',
    background:'#ffffff',
    padding:'30px',
    borderRadius:'20px',
    boxShadow:'0 5px 25px rgba(0,0,0,0.12)',
  },

  form:{
    display:'flex',
    flexDirection:'column',
    gap:'20px',
  },

  input:{
    padding:'18px',
    borderRadius:'10px',
    border:'1px solid #ccc',
    fontSize:'16px',
  },

  textarea:{
    padding:'18px',
    borderRadius:'10px',
    border:'1px solid #ccc',
    fontSize:'16px',
    minHeight:'180px',
  },

  button:{
    padding:'14px',
    borderRadius:'10px',
    border:'none',
    background:'#333',
    color:'#fff',
    fontSize:'16px',
    cursor:'not-allowed',
    opacity:0.6,
  }
};

export default ContactPage;